module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    class: [_vm.prefixCls],
    on: {
      "mouseenter": _vm.handleMouseenter,
      "mouseleave": _vm.handleMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-rel'],
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('Drop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentVisible),
      expression: "currentVisible"
    }],
    ref: "drop",
    attrs: {
      "placement": _vm.placement
    }
  }, [_vm._t("list")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebcd96a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/dropdown/dropdown.vue
// module id = 593
// module chunks = 1